// /frontend/src/pages/JobListings.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Typography, CircularProgress, Alert, Grid } from '@mui/material';
import JobCard from '../components/JobCard.js';
import JobFilters from '../components/JobFilters.js'; // 1. Importiamo il nuovo componente

const JobListings = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  // 2. Aggiungiamo uno stato per i filtri attivi
  const [activeFilters, setActiveFilters] = useState({});

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);
        // 3. La chiamata API ora invia i filtri come parametri
        const res = await axios.get('/api/jobs', { params: activeFilters });
        setJobs(res.data);
      } catch (err) {
        setError('Impossibile caricare le offerte di lavoro.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, [activeFilters]); // 4. Rieseguiamo il fetch ogni volta che i filtri cambiano

  // 5. Questa funzione viene passata al componente JobFilters
  const handleSearch = (filters) => {
    // Pulisce i filtri vuoti prima di aggiornare lo stato
    const newFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, value]) => value !== '')
    );
    setActiveFilters(newFilters);
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      <Typography variant="h4" gutterBottom>Opportunità di Lavoro</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Esplora le ultime offerte pubblicate dalle nostre aziende partner.
      </Typography>

      {/* 6. Inseriamo il componente dei filtri */}
      <JobFilters onSearch={handleSearch} />
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Box>
          {jobs.length > 0 ? (
            <Grid container spacing={3}>
              {jobs.map(job => (
                <Grid item key={job.id} xs={12} md={6} lg={4}>
                  <JobCard job={job} />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography sx={{ mt: 4, textAlign: 'center' }}>
              Nessun annuncio di lavoro trovato con i criteri di ricerca attuali.
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default JobListings;